import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { CardPaymentsStatusEnum } from '../../../payments-data/payments-data.data';

export const STRIPE_SCHEMA = Object.freeze({
  STATUS: CardPaymentsStatusEnum.disabled,
  EMAIL: null, // ''
  COUNTRY: null, // ''
  CURRENCY_CODE: null, // ''
  AVAILABLE_CARD_TYPES: List<string>([]),
  FEES_DESCRIPTION: '',
});
const RECORD = generateSchema(STRIPE_SCHEMA);
const KEYS: any = generateKeys(STRIPE_SCHEMA);

export class Stripe extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get status(): CardPaymentsStatusEnum {
    return this.get(KEYS.STATUS);
  }

  get email(): string {
    return this.get(KEYS.EMAIL);
  }

  get country(): string {
    return this.get(KEYS.COUNTRY);
  }

  get currencyCode(): string {
    return this.get(KEYS.CURRENCY_CODE);
  }

  get availableCardTypes(): List<string> {
    return this.get(KEYS.AVAILABLE_CARD_TYPES);
  }

  get feesDescription(): string {
    return this.get(KEYS.FEES_DESCRIPTION);
  }

  isEnabled(): boolean {
    return this.status === CardPaymentsStatusEnum.enabled;
  }

  isDisabled(): boolean {
    return this.status === CardPaymentsStatusEnum.disabled;
  }

  isIneligible(): boolean {
    return this.status === CardPaymentsStatusEnum.ineligible;
  }

  isUnderwritingRequired(): boolean {
    return this.status === CardPaymentsStatusEnum.underwriting_required;
  }
}
